import React from 'react';
import Text from '../../../../Components/Base/Text/Text';
// @ts-ignore
import styles from './MissingHealthPlanUserPlaceholder.module.scss';


const MissingHealthPlanUserPlaceholder: React.FC = () => {
	return (
		<div className={styles.wrapper}>
			<Text
				tx='component.missingHealthPlanUserPlaceholder.text'
				className={styles.text}
			/>
		</div>
	);
};

export default MissingHealthPlanUserPlaceholder;
